import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../styles/theme'

const StyledCheckbox = styled.input`
  display: inline-block;
  appearance: none;
  outline: 0;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background-color: ${colors.neutral100};

  &:not(:checked) {
    border: 1px solid ${props => props.theme.colors.separator};
  }

  &:checked {
    background: ${colors.primary300}
      url("data:image/svg+xml,%3Csvg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 7.5L4.5 11L14.5 1' stroke='%23F8F8F8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")
      no-repeat center;
    background-size: 60%;
  }
`

const Checkbox = ({ ...props }) => <StyledCheckbox type="checkbox" {...props} />

export default Checkbox
